import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { get } from 'lodash';

import { getRoutesProp } from 'utils/routing';

import couponsBetaFeatures from 'apps/coupons/betaFeatures';
import FopContent from '../../components/fopPartials/FopContent';

export default withRouter(connect((state, ownProps) => {
  const { user, externalisedStrings } = state;
  const { usePredefinedLabelForEDLP } = state.properties;

  return {
    betaFeatures: state.user.betaFeatures,
    usePredefinedLabelForEDLP,
    showCouponsLink: (
      ownProps.product && ownProps.product.coupon &&
      getRoutesProp(ownProps.router.routes, 'couponLinkOnFops') &&
      !(state.user.betaFeatures || []).includes(couponsBetaFeatures.COUPONS20_PER_COUPON_GROUPING) &&
      (state.user.betaFeatures || []).includes(couponsBetaFeatures.COUPONS20_LINK_ON_FOP)
    ),
    moreExclusiveOffer: {
      isMoreCardCustomer: get(user, 'customerDetails.isMoreCardCustomer', false),
      moreOffersUrl: get(externalisedStrings, 'accountSettings.PREFERENCES.moreOffersUrl', ''),
    },
  };
})(FopContent));
